import { t, Trans } from '@lingui/macro';
import { isEmpty } from 'lodash';
import DataTable from '../../../../data-table/DataTable';
import { useQueryLoader } from '../../../../data-table/Loaders';
import useNgpFormContext from '../../../../../utilities/NgpFormContextProviderUtilities';
import LinkButton from '../../../../links/LinkButton';
import { COLUMN_TYPES } from '../../../../data-table/DataTableColumns';
import { SORT_ASC } from '../../../../../utilities/FormUtilities';
import TestFormSection from './TestFormSection/TestFormSection';
import TestSubFormSection from './TestFormSection/TestSubFormSection';

const NOTIFICATIONS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'email',
        title: t`Email`,
        width: 200,
    },
];
export const initialSort = [{ property: 'email', direction: SORT_ASC }];

const NOTIFICATIONS_MANAGE_URL = '/admin/notifications';

function notificationsDataSource(recordId) {
    return {
        url: `/ngp/v2/inventory/subscribers/service-tests/${recordId}`,
        totalProperty: 'count',
        dataProperty: 'data',
        params: { searchFields: ['email'] },
    };
}

const VISIBLE_ROWS = 8;
const HIDDEN_ROWS = 0;

const TestNotificationsSection = ({ groupExist = true }) => {
    const { formData } = useNgpFormContext();
    const recordId = formData?._id;

    // For exception record, not query notification, keep old portal/ui logic
    const needQuery = !isEmpty(recordId) && groupExist;
    const visibleRows = needQuery ? VISIBLE_ROWS : HIDDEN_ROWS;

    const loader = useQueryLoader(needQuery ? notificationsDataSource(recordId) : null, {
        disableFilterState: true,
    });

    return (
        <TestFormSection title={<Trans>Notifications</Trans>}>
            <div>
                <LinkButton label={<Trans>Manage All Notifications</Trans>} newTab url={NOTIFICATIONS_MANAGE_URL} />
            </div>
            <TestSubFormSection useTestSmallSubFormSection>
                <DataTable
                    loader={loader}
                    columns={NOTIFICATIONS_COLUMNS}
                    disableCSVExport
                    disableColumnRemover
                    emptyText={''}
                    visibleRows={visibleRows}
                    sorters={initialSort}
                />
            </TestSubFormSection>
        </TestFormSection>
    );
};

export default TestNotificationsSection;
